<div class="container-fluid pt-6">
  @if (interviewState() && interviewState()?.currentQuestion) {
    <div class="row">
      <div class="content-panel">
        <div class="row mb-5">
          <div class="col">
            <h2 class="underline">{{ messages.getText('WILL.interview.title') }}</h2> <!-- aria -->
          </div>
        </div>
          <div class="row">
            <div class="col-lg-3 col-md-11 col-sm-12 col-12 pe-4 border border-right">
              <navigator
                #nav
                [navigator]="interviewState()!.navigator"
                [type]="type"
                [latestTopicId]="latestTopicId()"
                (jumpToTopic)="onJumpToTopic($event)"
                ></navigator>
            </div>
            <div class="col-lg-7 col-md-11 col-sm-12 col-12 px-4">
              @if (DEBUG) {
                <div class="alert alert-query" role="alert">
                  <h4>DEBUG:</h4>
                  <p><b>Current topic:</b>&nbsp;&nbsp;<span class="badge bg-secondary">{{ interviewState()?.navigator?.currentTopic }}</span></p>
                  <p><b>Current question:</b>&nbsp;&nbsp;<span class="badge bg-secondary">{{ interviewState()?.currentQuestion?.id }}</span></p>
                </div>
              }
              @if (interviewState()?.navigator?.currentTopic) {
                <h3 class="stageTitle" id="topicTitle" tabindex="-1">
                  {{ messages.getText(type + ".topic." + interviewState()!.navigator!.currentTopic!) }}
                </h3>
              }
              <!--
                Editing-an-earlier-answer banner (task 9, Requirement 7.4).
                Rendered only in edit mode, as an ARIA live region (role="status" +
                aria-live="polite") so it is announced when edit mode is entered.
                Associated with the question region via aria-describedby on the form
                below, which references this banner's id.
              -->
              @if (editingEarlierAnswer()) {
                <div id="editing-earlier-banner"
                     class="editing-earlier-banner alert alert-warning"
                     role="status"
                     aria-live="polite">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  <span>{{ messages.getText('WILL.interview.editing-banner', [messages.getText(type + '.topic.' + editTopicId())]) }}</span>
                </div>
              }
              <form class="component-form" [formGroup]="form" (ngSubmit)="doNothing()"
                    [attr.aria-describedby]="editingEarlierAnswer() ? 'editing-earlier-banner' : null">
                <div class="form-group position-relative topic-form py-4">
                  @if (interviewState()!.currentQuestion!.type === 'CHARITY_GROUP') {
                    <charity-gift-group-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [editingResponse]="editingEarlierAnswer()"
                      [onEnter]="triggerEvaluation()"
                    />

                  } @else if (interviewState()!.currentQuestion!.type === 'GROUP') {
                    <group-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [question]="interviewState()!.currentQuestion!"
                      [editingResponse]="editingEarlierAnswer()"
                      [onEnter]="triggerEvaluation()"
                    />
                  } @else if (interviewState()!.currentQuestion!.type!.endsWith("TEXT") || (interviewState()?.currentQuestion?.type?.endsWith('VIDEO') && !interviewState()?.metadata?.recordingConsented)) {
                    <text-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"></text-control>

                  } @else if (interviewState()!.currentQuestion!.type === "NOTE" || interviewState()!.currentQuestion!.type === "CONFIRM_OPTION") {
                    <confirm-option-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type === "CHECKBOX") {
                    <checkbox-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [editingResponse]="editingEarlierAnswer()"
                      [onEnter]="triggerEvaluation()"/>
                  } @else if (interviewState()!.currentQuestion!.type === "CHARITY") {
                    <charity-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [editingResponse]="editingEarlierAnswer()"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type === "CHARITY_SEARCH") {
                    <charity-search-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>
                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("VIDEO")) {
                    <video-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type === "DROPDOWN") {
                    <dropdown-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type === "RADIO") {
                    <radio-button-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("CURRENCY")) {
                    <currency-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("EMAIL")) {
                    <email-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("NUMBER")) {
                    <number-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("PERCENTAGE")) {
                    <percentage-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("POSTCODE")) {
                    <postcode-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("DATE")) {
                    <date-control
                      #questionControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()"/>

                  } @else if (interviewState()!.currentQuestion!.type?.endsWith("LINK")) {
                    <link-control
                      #linkControl
                      [baseForm]="this"
                      [form]="this.form"
                      [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
                      [questionId]="interviewState()!.currentQuestion!.id!"
                      [question]="interviewState()!.currentQuestion!"
                      [onEnter]="triggerEvaluation()" />

                  }
                  @if (interviewState()!.errors?.fatal) {
                    <div class="alert  alert-danger error pill form-error-list">
                      <div id="fatal-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
                        <div class="row">
                          <div class="col-auto align-self-center"><i class="fa fa-exclamation-triangle"></i></div>
                          <div class="col-11">{{ messages.getText(type + '.error.' + interviewState()!.errors!.fatal) }}</div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </form>
              @if (navigator?.currentTopic?.endInterview !== true) {
              <div class="row">
                <div class="col-12">
                  <div class="outer-button">
                    <button id="save"
                            [disabled]="loading || preventSave"
                            class="btn tertiary rounded-pill submit"
                            type="button" (click)="saveAndExit()" (keyup.enter)="saveAndExit()">
                      @if (loading) {
                        <span class="spinner-border spinner-border-sm mr-1"></span>
                      }
                      {{ messages.getText('WILL.button.save-and-exit', 'Save and exit') }}
                    </button>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
      </div>
    </div>
  } @else {
    <div class="d-flex" style="height: 50vh !important;">
      <div class="loading text-center p-16 mx-auto my-auto" style="background-color:rgb(216, 255, 110);border-radius:2rem">
        <div class="spinner-border text-primary" style="position:absolute;top:calc(50% - 8rem);left:calc(50% - 3rem);height:100px;width:100px;border-width:8px;margin-bottom:2rem;border-bottom-color: rgb(87, 59, 115);border-left-color: rgb(87, 59, 115);border-right-color: rgb(87, 59, 115);border-top-color: rgb(216, 255, 110);" role="status"></div>
        <h3 class="mx-6 pt-14">Loading, please wait...</h3>
      </div>
    </div>
  }

  <!-- Pre-edit confirmation for mid-interview backward navigation (task 8). -->
  <edit-confirmation-dialog #editConfirm></edit-confirmation-dialog>
</div>
